import { html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

import styles from "./scripture-callout.css";

@customElement("bp-scripture-callout")
export class ScriptureCallout extends LitElement {
  static styles = styles;

  @property()
  footnote?: string;

  @property()
  reference?: string;

  @property()
  translation?: string;

  render() {
    return html`
      <figure>
        <header>
          ${this.reference &&
          html` <span class="reference">${this.reference}</span> `}
          ${this.translation &&
          html` <span class="translation">${this.translation}</span> `}
        </header>

        <slot></slot>

        ${this.footnote && html` <footer>${this.footnote}</footer> `}

        <slot name="caption"></slot>
      </figure>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "bp-scripture-callout": ScriptureCallout;
  }
}
